import { Errors } from '../constants';
export var buildInternalError = function buildInternalError(errCode) {
  if (!errCode) {
    return;
  }

  return {
    'response': {
      'data': {
        'results': {
          'code': errCode
        }
      }
    }
  };
};